module.exports = "/assets/funding_postcode_selected-01ccd358c77c1cc3da38f51f257a457e.svg";